import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { ProductType } from '@classes/productType';

@Injectable({
  providedIn: 'root'
})
export class ProductTypesService {
    productTypesListChanged = new Subject<ProductType[]>();
    private baseUrl: string = environment.apiUrl + 'product-types';
    private productTypes: ProductType[];

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<ProductType[]> {
        return this.http.get<ProductType[]>(this.baseUrl)
        .pipe(
            map(productTypes => {
                this.productTypes = productTypes.map(c => ProductType.fromObject(c));
                this.productTypes.sort((a, b) => a.name.localeCompare(b.name));
                this.productTypesListChanged.next([ ...this.productTypes ]);
                return [ ...this.productTypes ];
            })
        );
    }

    put(container: ProductType): Observable<ProductType> {
        return this.http.put<ProductType>(this.baseUrl, container)
        .pipe(
            tap(editedProductType => {
                editedProductType = ProductType.fromObject(editedProductType);
                this.productTypes = this.productTypes.map(c => c.id === editedProductType.id ? editedProductType : c);
                this.productTypesListChanged.next([ ...this.productTypes ]);
            })
        );
    }

    post(container: ProductType): Observable<ProductType> {
        return this.http.post<ProductType>(this.baseUrl, container)
        .pipe(
            tap(createdProductType => {
                createdProductType = ProductType.fromObject(createdProductType);
                this.productTypes.push(createdProductType);
                this.productTypesListChanged.next([ ...this.productTypes ]);
            })
        );
    }

    delete(id: string): Observable<void> {
      return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
          tap(() => {
              this.productTypes = this.productTypes.filter(m => m.id !== id);
              this.productTypesListChanged.next([ ...this.productTypes ]);
          })
      );
  }
}
